import { createApi } from '@reduxjs/toolkit/query/react';
import { apiQuery } from 'core/rtkQuery';
import {
  PaginatedItemParameterDto,
  PaginatedItemParameterDtoFromJSON,
  ParameterDto,
} from 'apis/backendApi';
import { addQueryContext, WithQueryContext } from 'core/apiQueryContext';

export type GroupSelection = {
  parameter: string;
  filter: string;
  filterValue: string;
};

export type PageSelection = {
  pageNr: number;
  pageSize: number;
};

export type GroupParametersSelection = {
  groupSelection: GroupSelection | null;
  pageSelection: PageSelection;
};

const groupParametersApiDef = createApi({
  reducerPath: 'groupParametersApi',
  baseQuery: apiQuery(),
  refetchOnMountOrArgChange: 5,

  tagTypes: ['items'],

  endpoints: builder => ({
    getParametersForItems: builder.query<
      PaginatedItemParameterDto,
      WithQueryContext<GroupParametersSelection>
    >({
      query: ({ buCode, groupSelection, pageSelection }) => ({
        url: groupSelection ? '/parameters/v1/{buCode}/items' : null,
        pathVariables: { buCode },
        params: { ...groupSelection, ...pageSelection },
      }),

      transformResponse: json => PaginatedItemParameterDtoFromJSON(json),

      providesTags: ['items'],
    }),

    postParametersForItems: builder.mutation<
      void,
      WithQueryContext<{
        groupSelection: GroupSelection;
        parameter: ParameterDto;
      }>
    >({
      query: ({ buCode, groupSelection, parameter }) => {
        return {
          url: '/parameters/v1/{buCode}/items',
          pathVariables: { buCode },
          params: groupSelection,
          method: 'POST',
          body: parameter,
        };
      },

      invalidatesTags: ['items'],
    }),
  }),
});

const groupParametersApi = addQueryContext(groupParametersApiDef);

export const {
  useGetParametersForItemsQuery,
  usePostParametersForItemsMutation,
} = groupParametersApi;

export default groupParametersApi;
